import React from "react";
import { isMobileOnly } from "react-device-detect";
import { StrapiMedia } from "../../types/strapi";
import ImagesCarousel from "./ImagesCarousel";
import ImagesMovingText from "./ImagesMovingText";
import ImagesSequence from "./ImagesSequence";

interface ImagesProps {
  images?: StrapiMedia[];
  type?: string;
  cssClass?: string;
  toTop?: boolean;
}

const Images: React.FC<ImagesProps> = ({ images, type, cssClass, toTop }) => {
  if (type === "carousel") {
    return <ImagesCarousel images={images} toTop={toTop} cssClass={cssClass} />;
  }

  if (type === "movingText" && !isMobileOnly) {
    return (
      <div className="mb-xl-5">
        <ImagesMovingText images={images} />
      </div>
    );
  }

  if (type === "movingText" && isMobileOnly) {
    return <ImagesSequence images={images} />;
  }

  if (type === "sequence") {
    return <ImagesSequence images={images} />;
  }

  return "";
};

export default Images;
